var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 53,
    viewBox: "0 0 80 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_21660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4767 12.167L68.5525 45.6256L40 52.5395V17.8939L68.4767 12.167Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 5.77051L68.4767 12.1667L40 17.8936V5.77051Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5232 12.2425L39.9999 5.77051V17.8936L11.5232 12.2425Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5233 12.2427L40 17.8938V52.5394L11.4475 45.6255L11.5233 12.2427Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5083 12.1984L77.5185 6.30102L50.2478 0.460449L40 5.8022L68.5083 12.1984Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4917 12.1984L2.48145 6.30102L29.7522 0.460449L40 5.8022L11.4917 12.1984Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5083 12.1982L80 22.6355L49.8753 29.0317L40 17.9125L68.5083 12.1982Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8753 29.0318L68.5083 25.0728L48.3852 31.0839L40 17.9126L49.8753 29.0318Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 52.2995V52.5394L11.4475 45.6254L11.517 13.6128C13.0639 35.245 30.4278 47.2734 40 52.2995Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4917 12.1982L0 22.6355L30.1247 29.0317L40 17.9125L11.4917 12.1982Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1247 29.0318L11.4917 25.0728L31.6148 31.0839L40 17.9126L30.1247 29.0318Z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_21660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 52.0789,
    fill: "white",
    transform: "translate(0 0.460449)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.93b031920bba54a6dd12b1d0e911f0a0.svg";
export { ForwardRef as ReactComponent };